import app from 'flarum/forum/app';
import ScheduledPost from '../models/ScheduledPost';

export default class ScheduledPostListState {
	/**
	 * Whether or not the scheduled posts are loading.
	 */
	loading: boolean = false;

	/**
	 * Cache array (currently unused).
	 */
	cache: any[] = [];

	/**
	 * Array of scheduled posts.
	 */
	scheduledPosts: ScheduledPost[] = [];

	load(clear: boolean = true): Promise<void> {
		if (clear) {
			this.loading = true;
			this.scheduledPosts = [];
		}

		return app.store.find<ScheduledPost[]>('scheduled_posts').then(
			(results) => {
				this.scheduledPosts = [];
				this.parseResults(results);
			},
			() => {
				this.loading = false;
				m.redraw();
			}
		);
	}

	parseResults(results: ScheduledPost[]): ScheduledPost[] {
		this.scheduledPosts.push(...results);

		this.loading = false;

		m.redraw();

		return results;
	}
}
